__turbopack_context__.v({
  "border": "card-module__e_krJq__border",
  "brand": "card-module__e_krJq__brand",
  "grey-dark": "card-module__e_krJq__grey-dark",
  "grey-light": "card-module__e_krJq__grey-light",
  "ideeri": "card-module__e_krJq__ideeri",
  "ideeri-contrast": "card-module__e_krJq__ideeri-contrast",
  "shadow": "card-module__e_krJq__shadow",
  "wrapper": "card-module__e_krJq__wrapper",
});
